import { UserManager } from 'oidc-client';


export default class authService {
    userManager;

    constructor() {
        const AUTH0_DOMAIN = "https://test-auth.candidate-concierge.com/";

        var settings = {
            authority: AUTH0_DOMAIN,
            client_id: "dcc-spa-client",
            response_type: "code",
            scope: "openid profile offline_access roles dcc-api dccAdmin_api",
            filterProtocolClaims: true,
            automaticSilentRenew: true,
            loadUserInfo: true,
            response_mode:"query",
                    
            //Env
            redirect_uri: "https://test-admin.candidate-concierge.com/callback.html",
            post_logout_redirect_uri: "https://test-admin.candidate-concierge.com/post-logout-callback.html",
            silent_redirect_uri: 'https://test-admin.candidate-concierge.com/silent-renew.html'
    
            //Localhost
            // redirect_uri: "http://localhost:8080/callback.html",
            // post_logout_redirect_uri: "http://localhost:8080/post-logout-callback.html",
            // silent_redirect_uri: 'http://localhost:8080/silent-renew.html'
        }

        this.userManager = new UserManager(settings);
    }

    getUser() {
        return this.userManager.getUser();
    }

    login() {
        return this.userManager.signinRedirect();
    }

    logout() {
        return this.userManager.signoutRedirect();
    }
}